import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    en: {
        translation: {
            welcome: 'Welcome',
            login: 'Login',
            logout: 'Logout',
            partnerList: 'Partner List',
            partnerProfile: 'Partner Profile',
            editPartner: 'Edit Partner',
            language: 'Language',
            menu: 'Menu',
            email: 'Email',
            password: 'Password',
            rememberMe: 'Remember Me',
            forgotPassword: 'Forgot Password?',
            signIn: 'Sign In',
            dontHaveAccount: "Don't have an account?",
            signUp: 'Sign Up',
            search: 'Search',
            addNewPartner: 'Add New Partner',
            name: 'Name',
            phone: 'Phone',
            status: 'Status',
            actions: 'Actions',
            edit: 'Edit',
            delete: 'Delete',
            view: 'View',
            active: 'Active',
            inactive: 'Inactive',
            personalInfo: 'Personal Information',
            contactInfo: 'Contact Information',
            address: 'Address',
            city: 'City',
            country: 'Country',
            postalCode: 'Postal Code',
            save: 'Save',
            cancel: 'Cancel',
            update: 'Update',
            confirmDelete: 'Are you sure you want to delete?',
            yes: 'Yes',
            no: 'No',
            loading: 'Loading...',
            error: 'Error',
            success: 'Success',
            required: 'Required',
            invalidEmail: 'Invalid email address',
            invalidPhone: 'Invalid phone number',
            saveSuccess: 'Successfully saved',
            updateSuccess: 'Successfully updated',
            deleteSuccess: 'Successfully deleted',
            buildDreamHome: 'Build your dream home',
            tagline: 'PlanNbuild connects you with expert architects, verified builders, and onsite inspectors giving you full control, insight, and security at every stage of your construction journey.',
            welcomeBack: 'Welcome back to PlanNbuild!',
            enterCredentials: 'Enter your Credentials to access your account',
            enterEmail: 'Enter your email',
            enterPassword: 'Enter password',
            supplier: 'Supplier',
            architect: 'Architect',
            builders: 'Builders',
            marketplace: 'Marketplace',
            supplierList: 'Supplier List',
            architectList: 'Architect List',
            buildersList: 'Builders List',
            addPartner: 'Add Partner',
            searchCompanyName: 'Search with company name',
            basicInfo: 'Basic Information',
            professionalInfo: 'Professional Information',
            profileImage: 'Profile Image',
            enterCompanyName: 'Enter company name',
            enterPhone: 'Enter phone number',
            enterWebsite: 'Enter website URL',
            enterSpecialties: 'Enter specialties',
            enterExperience: 'Enter years of experience',
            profilePreview: 'Profile Preview',
            companyName: 'Company Name',
            phoneNumber: 'Phone Number',
            website: 'Website',
            specialties: 'Specialties',
            experience: 'Experience',
            profilePreview: 'Profile Preview',
            about: 'About',
            bio: 'Bio',
            save: 'Save',
            personalInformation: 'Personal Information',
            companyInformation: 'Company Information',
            supplier: 'Supplier',
            architect: 'Architect',
            builders: 'Builders',
            overview: 'Overview',
            projects: 'Projects',
            financial: 'Financial',
            users: 'Users',
            roles: 'Roles',
            settings: 'Settings',
            logout: 'Logout',
            searchForAnything: 'Search for anything',
            total: 'Total',
            pendingMilestoneApprovals: 'Pending Milestone Approvals',
            openIncidents: 'Open Incidents',
            newSignups: 'New Signups (This Week)',
            alerts: 'Alerts',
            filters: 'Filters',
            incidents: 'Incidents',
            all: 'All',
            important: 'Important',
            pending: 'Pending',
            latestIncidents: 'Latest incidents',
            inspectorActivity: 'Inspector Activity',
            escalationCenter: 'Escalation Center',
            projectDetails: 'Project Details',
            team: 'Team',
            download: 'Download',
            message: 'Message',
            architect: 'Architect',
            inspector: 'Inspector',
            currentMilestone: 'Current Milestone',
            escrowBalance: 'Escrow Balance',
            latestUpdate: 'Latest Update',
            totalFundsHeld: 'Total Funds Held',
            releasedThisMonth: 'Released This Month',
            pendingMilestonePayouts: 'Pending Milestone Payouts',
            platformRevenue: 'Platform Revenue',
            milestoneLog: 'Milestone Log',
            totalVendors: 'Total Vendors',
            pendingApprovals: 'Pending Approvals',
            samplePendingVendor: 'Sample Pending Vendor',
            topProductsSold: 'Top Products Sold',
            viewAll: 'View All',
            selected: 'selected',
            addUser: 'Add User',
            registered: 'Registered',
            clients: 'Clients',
            suppliers: 'Suppliers',
            architects: 'Architects',
            builders: 'Builders',
            inspectors: 'Inspectors',
            admins: 'Administrators',
            superAdmins: 'Super Administrators',
            verified: 'Verified',
            certified: 'Certified',
            architects: 'Architects',
            userList: 'User List',
            profile: 'Profile',
            changePassword: 'Change Password',
            firstName: 'First Name',
            lastName: 'Last Name',
            contactNumber: 'Contact Number',
            whatsappNumber: 'Whatsapp Number',
            state: 'State',
            city: 'City',
            postalCode: 'Postal Code',
            isWhatsappNo: 'Is Whatsapp Number',
            emailId: 'Email ID',
            companyName: 'Company Name',
            website: 'Website',
            languagePreference: 'Language preference',
            role: 'Role',
            street: 'Street',
            country: 'Country',
            countryCode: 'Country Code',
            zip: 'Zip',
            specialities: 'Specialities',
            state: 'State',
            city: 'City',
            bio: 'Bio',
            roleDetails: 'Role Details',
            roleInformation: 'Role Information',
            roleName: 'Role Name',
            description: 'Description',
            createdAt: 'Created At',
            permissions: 'Permissions',
            loadingPermissions: 'Loading permissions...',
            searchPermissions: 'Search permissions...',
            totalPermissions: 'Total permissions',
            filterBy: 'Filter by',
            allStatus: 'All status',
            assigned: 'Assigned',
            unassigned: 'Unassigned',
            permissionName: 'Permission Name',
            status: 'Status',
            actions: 'Actions',
            completed: 'Completed',
            pending: 'Pending',
            inProgress: 'In Progress',
            onHold: 'On Hold',
            cancelled: 'Cancelled',
            approved: 'Approved',
            rejected: 'Rejected',
            faqs: 'FAQs',
            submitTicket: 'Submit a Ticket',
            selectCategory: 'Select Category',
            ifYourIssueIsNotCoveredInTheFAQPleaseOpenASupportTicket: 'If your issue is not covered in the FAQ, please open a support ticket.',
            subject: 'Subject',
            submit: 'Submit',
            yourRecentTickets: 'Your Recent Tickets',
            assignedProjects: 'Assigned Projects',
            inventoryTableView: 'Inventory Table View',
            certification: 'Certification',
            designStudio: 'Design Studio',
            designFileManager: 'Design File Manager',
            uploadNewDesign: 'Upload New Design',
            clientFeedback: 'Client Feedback',
            recentApprovalsTracker: 'Recent Approvals Tracker',
            inspections: 'Inspections',
            myBids: 'My Bids',
            marketplace: 'Marketplace',
            inStock: 'In Stock',
            stockStatus: 'Stock Status',
            category: 'Category',
            addNewProduct: 'Add New Product',
            inventoryTableView: 'Inventory Table View',
            inspectorReports: 'Inspector Reports',
            incidentReportTable: 'Incident Report Table',
            tabName: 'Tab Name',
            accounts: 'Accounts',
            manageStaffMembers: 'Manage staff members',
            add: 'Add',
            addStaff: 'Add Staff',
            addingStaff: 'Adding Staff...',
            project: 'Project',
            plot: 'Plot',
            submitPlot: 'Submit Plot',
            addingPlot: 'Adding Plot...',
            addProject: 'Add Project',
            columns: 'Columns',
            projectName: 'Project Name',
            lotSize: 'Lot Size',
            projectInformation: 'Project Information',
            addressInformation: 'Address Information',
            plotInformation: 'Plot Information',
            projectImages: 'Project Images',
            projectFiles: 'Project Files',
            fileCabinet: 'File Cabinet',
            back: 'Back',
            addFiles: 'Add Files',
            backtoProjects: 'Back to Projects',
            editProject: 'Edit Project',
            existingImages: 'Existing Images',
            uploadNewImages: 'Upload New Images',
            drag: 'Drag',
            dropimagestorearrange: 'drop images to rearrange',
            fileName: 'File Name',
            availability: 'Availability',
            visibility: 'Visibility',
            files: 'Files',
            backtoFileCabinet: 'Back to File Cabinet',
            editFileCabinet: 'Edit File Cabinet',
            noFileCabinetData: 'No File Cabinet Data',
            existingFiles: 'Existing Files',
            goToFileCabinet: 'Go to File Cabinet',
            plotDetails: 'Plot Details',
            plotImages: 'Plot Images',
            plotFiles: 'Plot Files',
            assign: 'Assign',
            addPlot: 'Add Plot',
            accountInformation: 'Account Information',
            locationInformation: 'Location Information',
            architect: 'Architect',
            builder: 'Builder',
            inspector: 'Inspector',
            supplier: 'Supplier',
            client: 'Client',
            resetForm: 'Resetar formulário',
            submit: 'Enviar',
            addingUser: 'Adicionando usuário...',
            addingUser: 'Adicionando usuário...',
            companyName: 'Company Name',
            showHideColumns: 'Show/Hide Columns',
            deletingUser: 'Deleting user...',
            usersLoading: 'Users loading...',
            updating: 'Updating...',
            updateProject: 'Update Project',
            done: 'Done',
            selectArchitects: 'Select Architects',
            selectBuilders: 'Select Builders',
            selectSuppliers: 'Select Suppliers',
            selectInspectors: 'Select Inspectors',
            addingPlot: 'Adding Plot...',
            submitPlot: 'Submit Plot',
            countryName: 'Country Name',
            stateName: 'State Name',
            cityName: 'City Name',
            zipCode: 'Zip Code',
            view: 'View',
            edit: 'Edit',
            delete: 'Delete',
            deleting: 'Deleting...',
            noMessagesYet: 'No messages yet',
            chat: 'Chat',
            loadingPlotDetails: 'Loading plot details...',
            clientInformation: 'Client information',
            folderName: 'Folder Name',
            addingLot: 'Adding lot...',
            submitLot: 'Submit Lot',
            plotName: 'Plot Name',
            plotSize: 'Plot Size',
            plotDetails: 'Plot Details',
            clientName: 'Client Name',
            clientImage: 'Client Image',
            cabinetFiles: 'Cabinet Files',
            hello: 'Hello',
            quick: 'Quick',
            quickSearch: 'Quick Search',
            favorites: 'Favorites',
            filter: 'Filter',
            home: 'Home',
            propertyType: 'Property Type',
            myFilter: 'My Filter',
            addFilter: 'Add Filter',
            editFilter: 'Edit Filter',
            apply: 'Apply',
            clearAll: 'Clear All',
            personalInformation: 'Personal Information',
            profileInformation: 'Profile Information',
            contactDetails: 'Contact Details',
            addressDetails: 'Address Details',
            saveChanges: 'Save Changes',
            discardChanges: 'Discard Changes',
            changeEmailId: 'Change Email Id',
            pushNotification: 'Push Notification',
            changePassword: 'Change Password',
            logOut: 'Log Out',
            price: 'Price',
            rooms: 'Rooms',
            askInformation: 'Ask Information',
            areYouSureYouWantToLogout: 'Are you sure you want to log out?',
            confirmLogout: 'Confirm Logout',
            cancel: 'Cancel',
            logOut: 'Log Out',
            portfolioFilter: 'Portfolio Filter',
            location: 'Location',
            bedrooms: 'Bedrooms',
            bathrooms: 'Bathrooms',
            phoneNo: 'Phone No.',
            noDataFound: 'No data found',
            pleaseWaitWhileWeFetchTheFavorites: 'Please wait while we fetch the favorites',
            noPropertiesMatchYourCurrentFiltersTryAdjustingYourSearchCriteria: 'No properties match your current filters. Try adjusting your search criteria.',
            noPropertiesAvailableAtTheMoment: 'No properties available at the moment.',
            pleaseWaitWhileWeFetchTheNotifications: 'Please wait while we fetch the notifications',
            noNotificationsFound: 'No notifications found',
            noNotificationsMatchYourCurrentFiltersTryAdjustingYourSearchCriteria: 'No notifications match your current filters. Try adjusting your search criteria.',
            noNotificationsAvailableAtTheMoment: 'No notifications available at the moment.',
            pleaseWaitWhileWeFetchTheProperties: 'Please wait while we fetch the properties',
            pleaseWaitWhileWeFetchTheFilters: 'Please wait while we fetch the filters',
            noFiltersFound: 'No filters found',
            youHaveNotCreatedAnyFiltersYetClickAddFilterToCreateOne: 'You haven\'t created any filters yet. Click "Add Filter" to create one.',
            pleaseWaitWhileWeFetchThePropertyDetails: 'Please wait while we fetch the property details',
            dimension: 'Dimension',
            garage: 'Garage',
            parking: 'Parking',
            noNotifications: 'No notifications',
            notifications: 'Notifications',
            markAllAsRead: 'Mark all as read',
        }
    },
    fr: {
        translation: {
            architect: 'Architecte',
            welcome: 'Bienvenue',
            login: 'Connexion',
            logout: 'Déconnexion',
            partnerList: 'Liste des partenaires',
            partnerProfile: 'Profil du partenaire',
            editPartner: 'Modifier le partenaire',
            language: 'Langue',
            menu: 'Menu',
            email: 'E-mail',
            password: 'Mot de passe',
            rememberMe: 'Se souvenir de moi',
            forgotPassword: 'Mot de passe oublié?',
            signIn: 'Se connecter',
            dontHaveAccount: "Vous n'avez pas de compte?",
            signUp: "S'inscrire",
            search: 'Rechercher',
            addNewPartner: 'Ajouter un nouveau partenaire',
            name: 'Nom',
            phone: 'Téléphone',
            status: 'Statut',
            actions: 'Actions',
            edit: 'Modifier',
            delete: 'Supprimer',
            view: 'Voir',
            active: 'Actif',
            inactive: 'Inactif',
            personalInfo: 'Informations personnelles',
            contactInfo: 'Informations de contact',
            address: 'Adresse',
            city: 'Ville',
            country: 'Pays',
            postalCode: 'Code postal',
            save: 'Enregistrer',
            cancel: 'Annuler',
            update: 'Mettre à jour',
            confirmDelete: 'Êtes-vous sûr de vouloir supprimer?',
            yes: 'Oui',
            no: 'Non',
            loading: 'Chargement...',
            error: 'Erreur',
            success: 'Succès',
            required: 'Requis',
            invalidEmail: 'Adresse e-mail invalide',
            invalidPhone: 'Numéro de téléphone invalide',
            saveSuccess: 'Enregistré avec succès',
            updateSuccess: 'Mis à jour avec succès',
            deleteSuccess: 'Supprimé avec succès',
            buildDreamHome: 'Construisez votre maison de rêve',
            tagline: 'PlanNbuild vous connecte avec des architectes experts, des constructeurs vérifiés et des inspecteurs sur site, vous donnant un contrôle total, une visibilité et une sécurité à chaque étape de votre parcours de construction.',
            welcomeBack: 'Bienvenue sur PlanNbuild !',
            enterCredentials: 'Entrez vos identifiants pour accéder à votre compte',
            enterEmail: 'Entrez votre e-mail',
            enterPassword: 'Entrez votre mot de passe',
            supplier: 'Fournisseur',
            architect: 'Architecte',
            builders: 'Constructeurs',
            marketplace: 'Place de marché',
            supplierList: 'Liste des fournisseurs',
            architectList: 'Liste des architectes',
            buildersList: 'Liste des constructeurs',
            addPartner: 'Ajouter un partenaire',
            searchCompanyName: 'Rechercher par nom d\'entreprise',
            basicInfo: 'Informations de base',
            professionalInfo: 'Informations professionnelles',
            profileImage: 'Image de profil',
            enterCompanyName: 'Entrez le nom de l\'entreprise',
            enterPhone: 'Entrez le numéro de téléphone',
            enterWebsite: 'Entrez l\'URL du site web',
            enterSpecialties: 'Entrez les spécialités',
            enterExperience: 'Entrez les années d\'expérience',
            profilePreview: 'Aperçu du profil',
            companyName: 'Nom de l\'entreprise',
            phoneNumber: 'Numéro de téléphone',
            website: 'Site web',
            specialties: 'Spécialités',
            experience: 'Expérience',
            profilePreview: 'Aperçu du profil',
            about: 'À propos',
            bio: 'Bio',
            save: 'Enregistrer',
            personalInformation: 'Informations personnelles',
            companyInformation: 'Informations de l\'entreprise',
            supplier: 'Fournisseur',
            architect: 'Architecte',
            builders: 'Constructeurs',
            overview: 'Aperçu',
            projects: 'Projets',
            financial: 'Financier',
            users: 'Utilisateurs',
            roles: 'Rôles',
            settings: 'Paramètres',
            logout: 'Déconnexion',
            searchForAnything: 'Rechercher n\'importe quoi',
            total: 'Total',
            pendingMilestoneApprovals: 'Approbations de points de marque en attente',
            openIncidents: 'Incidents ouverts',
            newSignups: 'Nouveaux inscrits (Cette semaine)',
            alerts: 'Alertes',
            filters: 'Filtres',
            incidents: 'Incidents',
            all: 'Tous',
            important: 'Important',
            pending: 'En attente',
            latestIncidents: 'Derniers incidents',
            inspectorActivity: 'Activité de l\'inspecteur',
            escalationCenter: 'Centre d\'escalade',
            projectDetails: 'Détails du projet',
            team: 'Équipe',
            download: 'Télécharger',
            message: 'Message',
            architect: 'Architecte',
            inspector: 'Inspeteur',
            currentMilestone: 'Point de marque actuel',
            escrowBalance: 'Solde de l\'escrow',
            latestUpdate: 'Dernière mise à jour',
            totalFundsHeld: 'Total des fonds détenus',
            releasedThisMonth: 'Sorti ce mois',
            pendingMilestonePayouts: 'Payouts de points de marque en attente',
            platformRevenue: 'Revenu de la plateforme',
            milestoneLog: 'Journal des points de marque',
            totalVendors: 'Total des fournisseurs',
            pendingApprovals: 'Approbations en attente',
            samplePendingVendor: 'Exemple de fournisseur en attente',
            topProductsSold: 'Produits les plus vendus',
            viewAll: 'Voir tout',
            selected: 'sélectionné',
            addUser: 'Ajouter un utilisateur',
            registered: 'Inscrit',
            clients: 'Clients',
            suppliers: 'Fournisseurs',
            architects: 'Architectes',
            builders: 'Constructeurs',
            inspectors: 'Inspecteurs',
            admins: 'Administrateurs',
            superAdmins: 'Super Administrateurs',
            verified: 'Vérifié',
            certified: 'Certifié',
            architects: 'Architectes',
            userList: 'Liste des utilisateurs',
            profile: 'Profil',
            changePassword: 'Changer le mot de passe',
            firstName: 'Prénom',
            lastName: 'Nom',
            contactNumber: 'Numéro de téléphone',
            whatsappNumber: 'Numéro de WhatsApp',
            state: 'État',
            city: 'Ville',
            postalCode: 'Code postal',
            isWhatsappNo: 'Is Whatsapp Number',
            emailId: 'Email ID',
            companyName: 'Nom de l\'entreprise',
            website: 'Site web',
            languagePreference: 'Préférence de langue',
            role: 'Rôle',
            street: 'Rue',
            country: 'Pays',
            countryCode: 'Code pays',
            zip: 'Code postal',
            specialities: 'Spécialités',
            state: 'État',
            city: 'Ville',
            bio: 'Bio',
            roleDetails: 'Détails du rôle',
            roleInformation: 'Informations du rôle',
            roleName: 'Nom du rôle',
            description: 'Description',
            createdAt: 'Créé le',
            permissions: 'Permissions',
            loadingPermissions: 'Loading permissions...',
            searchPermissions: 'Rechercher des permissions...',
            totalPermissions: 'Total des permissions',
            filterBy: 'Filtrer par',
            allStatus: 'Tous les statuts',
            assigned: 'Assigné',
            unassigned: 'Non assigné',
            permissionName: 'Nom de la permission',
            status: 'Statut',
            actions: 'Actions',
            completed: 'Terminé',
            pending: 'En attente',
            inProgress: 'En cours',
            onHold: 'En attente',
            cancelled: 'Annulé',
            approved: 'Approuvé',
            rejected: 'Rejeté',
            faqs: 'FAQs',
            submitTicket: 'Envoyer un ticket',
            selectCategory: 'Sélectionner une catégorie',
            ifYourIssueIsNotCoveredInTheFAQPleaseOpenASupportTicket: 'Si votre problème n\'est pas couvert dans les FAQ, veuillez ouvrir un ticket de support.',
            subject: 'Sujet',
            submit: 'Envoyer',
            yourRecentTickets: 'Vos tickets récents',
            assignedProjects: 'Projets assignés',
            inventoryTableView: 'Vue de table de l\'inventaire',
            certification: 'Certification',
            designStudio: 'Design Studio',
            designFileManager: 'Gestionnaire de fichiers de conception',
            uploadNewDesign: 'Télécharger un nouveau design',
            clientFeedback: 'Feedback du client',
            recentApprovalsTracker: 'Suivi des approbations récentes',
            inspections: 'Inspections',
            myBids: 'My Bids',
            marketplace: 'Marketplace',
            inStock: 'In Stock',
            stockStatus: 'Stock Status',
            category: 'Catégorie',
            addNewProduct: 'Ajouter un nouveau produit',
            inventoryTableView: 'Vue de table de l\'inventaire',
            inspectorReports: 'Rapports de l\'inspecteur',
            incidentReportTable: 'Tableau des rapports d\'incidents',
            tabName: 'Nom de l\'onglet',
            accounts: 'Comptes',
            manageStaffMembers: 'Gérer les membres de l\'équipe',
            add: 'Ajouter',
            addStaff: 'Ajouter un membre de l\'équipe',
            addingStaff: 'Ajout d\'un membre de l\'équipe...',
            project: 'Projet',
            plot: 'Lote',
            submitPlot: 'Submit Plot',
            addingPlot: 'Adding Plot...',
            addProject: 'Add Ajouter un projet',
            columns: 'Colonnes',
            projectName: 'Nom du projet',
            lotSize: 'Taille du lot',
            projectInformation: 'Informations sur le projet',
            addressInformation: 'Informations sur ladresse',
            plotInformation: 'Informations sur lintrigue',
            projectImages: 'Images du projet',
            projectFiles: 'Fichiers de projet',
            fileCabinet: 'classeur',
            back: 'Dos',
            addFiles: 'Ajouter des fichiers',
            backtoProjects: 'Retour aux projets',
            editProject: 'Modifier le projet',
            existingImages: 'Images existantes',
            uploadNewImages: 'Télécharger de nouvelles images',
            drag: 'Traîner',
            dropimagestorearrange: 'déposer les images pour les réorganiser',
            fileName: 'Nom de fichier',
            availability: 'Disponibilité',
            visibility: 'Visibilité',
            files: 'Fichiers',
            backtoFileCabinet: 'Retour au classeur',
            editFileCabinet: 'Modifier le classeur',
            noFileCabinetData: 'Aucune donnée de classeur',
            existingFiles: 'Fichiers existants',
            goToFileCabinet: 'Aller au classeur',
            plotDetails: 'Détails du lote',
            plotImages: 'Images du lote',
            plotFiles: 'Fichiers du lote',
            assign: 'Assigner',
            addPlot: 'Ajouter un lote',
            accountInformation: 'Informations du compte',
            locationInformation: 'Informations de localisation',
            builder: 'Builder',
            inspector: 'Inspector',
            supplier: 'Supplier',
            client: 'Client',
            resetForm: 'Resetar formulário',
            submit: 'Enviar',
            addingUser: 'Adicionando usuário...',
            addingUser: 'Adicionando usuário...',
            companyName: 'Nome da empresa',
            showHideColumns: 'Mostrar/Ocultar colunas',
            deletingUser: 'Deleting user...',
            usersLoading: 'Users loading...',
            updating: 'Mise à jour...',
            updateProject: 'Projet de mise à jour',
            done: 'Feito',
            selectArchitects: 'Selecionar arquitetos',
            selectBuilders: 'Selecionar construtores',
            selectSuppliers: 'Selecionar fornecedores',
            selectInspectors: 'Selecionar inspetores',
            addingPlot: 'Adicionando plot...',
            submitPlot: 'Enviar plot',
            countryName: 'Land naam',
            stateName: 'Staat naam',
            cityName: 'Plaats naam',
            zipCode: 'Postcode',
            view: 'Bekijk',
            edit: 'Bewerken',
            delete: 'Verwijderen',
            deleting: 'Verwijderen...',
            noMessagesYet: 'Geen berichten nog',
            chat: 'Chat',
            loadingPlotDetails: 'Plot details laden...',
            clientInformation: 'Client informatie',
            folderName: 'Map naam',
            addingLot: 'Plot toevoegen...',
            submitLot: 'Plot toevoegen',
            plotName: 'Plot naam',
            plotSize: 'Plot grootte',
            plotDetails: "Détails de l'intrigue",
            clientName: 'Nom du client',
            clientImage: 'Image du client',
            cabinetFiles: 'Fichiers do armário',
            hello: 'Bonjour',
            quick: 'Rapide',
            quickSearch: 'Recherche rapide',
            favorites: 'Favoris',
            filter: 'Filtre',
            home: 'Accueil',
            propertyType: 'Type de propriété',
            myFilter: 'Mon filtre',
            addFilter: 'Ajouter un filtre',
            editFilter: 'Modifier le filtre',
            apply: 'Appliquer',
            clearAll: 'Tout effacer',
            personalInformation: 'Informations personnelles',
            profileInformation: 'Informations du profil',
            contactDetails: 'Informations de contact',
            addressDetails: 'Informations d\'adresse',
            saveChanges: 'Enregistrer les modifications',
            discardChanges: 'Annuler les modifications',
            changeEmailId: 'Changer l\'email',
            pushNotification: 'Notification push',
            changePassword: 'Changer le mot de passe',
            logOut: 'Se déconnecter',
            price: 'Prix',
            rooms: 'Chambres',
            askInformation: 'Demander des informations',
            areYouSureYouWantToLogout: 'Are you sure you want to log out?',
            confirmLogout: 'Confirm Logout',
            cancel: 'Cancel',
            logOut: 'Log Out',
            portfolioFilter: 'Filtre de portefeuille',
            location: 'Emplacement',
            bedrooms: 'Chambres',
            bathrooms: 'Salles de bain',
            phoneNo: 'Numéro de téléphone',
            noDataFound: 'Aucune donnée trouvée',
            pleaseWaitWhileWeFetchTheFavorites: 'Veuillez patienter pendant que nous récupérons les favoris',
            noPropertiesMatchYourCurrentFiltersTryAdjustingYourSearchCriteria: 'Aucune propriété correspondant à vos filtres actuels. Essayez de modifier vos critères de recherche.',
            noPropertiesAvailableAtTheMoment: 'Aucune propriété disponible à ce moment.',
            pleaseWaitWhileWeFetchTheNotifications: 'Veuillez patienter pendant que nous récupérons les notifications',
            noNotificationsFound: 'Aucune notification trouvée',
            noNotificationsMatchYourCurrentFiltersTryAdjustingYourSearchCriteria: 'Aucune notification correspondant à vos filtres actuels. Essayez de modifier vos critères de recherche.',
            noNotificationsAvailableAtTheMoment: 'Aucune notification disponible à ce moment.',
            pleaseWaitWhileWeFetchTheProperties: 'Veuillez patienter pendant que nous récupérons les propriétés',
            pleaseWaitWhileWeFetchTheFilters: 'Veuillez patienter pendant que nous récupérons les filtres',
            noFiltersFound: 'Aucun filtre trouvé',
            youHaveNotCreatedAnyFiltersYetClickAddFilterToCreateOne: 'Vous n\'avez pas créé de filtre encore. Cliquez sur "Ajouter un filtre" pour en créer un.',
            pleaseWaitWhileWeFetchThePropertyDetails: 'Veuillez patienter pendant que nous récupérons les détails de la propriété',
            dimension: 'Dimension',
            garage: 'Garage',
            parking: 'Parking',
            noNotifications: 'Aucune notification',
            notifications: 'Notifications',
            markAllAsRead: 'Marquer tout comme lu',
        }
    },
    nl: {
        translation: {
            architect: 'Architect',
            welcome: 'Welkom',
            login: 'Inloggen',
            logout: 'Uitloggen',
            partnerList: 'Partnerlijst',
            partnerProfile: 'Partnerprofiel',
            editPartner: 'Partner bewerken',
            language: 'Taal',
            menu: 'Menu',
            email: 'E-mail',
            password: 'Wachtwoord',
            rememberMe: 'Onthoud mij',
            forgotPassword: 'Wachtwoord vergeten?',
            signIn: 'Inloggen',
            dontHaveAccount: 'Nog geen account?',
            signUp: 'Registreren',
            search: 'Zoeken',
            addNewPartner: 'Nieuwe partner toevoegen',
            name: 'Naam',
            phone: 'Telefoon',
            status: 'Status',
            actions: 'Acties',
            edit: 'Bewerken',
            delete: 'Verwijderen',
            view: 'Bekijken',
            active: 'Actief',
            inactive: 'Inactief',
            personalInfo: 'Persoonlijke informatie',
            contactInfo: 'Contactgegevens',
            address: 'Adres',
            city: 'Stad',
            country: 'Land',
            postalCode: 'Postcode',
            save: 'Opslaan',
            cancel: 'Annuleren',
            update: 'Bijwerken',
            confirmDelete: 'Weet je zeker dat je wilt verwijderen?',
            yes: 'Ja',
            no: 'Nee',
            loading: 'Laden...',
            error: 'Fout',
            success: 'Succes',
            required: 'Verplicht',
            invalidEmail: 'Ongeldig e-mailadres',
            invalidPhone: 'Ongeldig telefoonnummer',
            saveSuccess: 'Succesvol opgeslagen',
            updateSuccess: 'Succesvol bijgewerkt',
            deleteSuccess: 'Succesvol verwijderd',
            buildDreamHome: 'Bouw je droomhuis',
            tagline: 'PlanNbuild verbindt je met ervaren architecten, geverifieerde bouwers en inspecteurs ter plaatse, waardoor je volledige controle, inzicht en veiligheid hebt in elke fase van je bouwtraject.',
            welcomeBack: 'Welkom terug bij PlanNbuild!',
            enterCredentials: 'Voer je inloggegevens in om toegang te krijgen tot je account',
            enterEmail: 'Voer je e-mailadres in',
            enterPassword: 'Voer je wachtwoord in',
            supplier: 'Leverancier',
            architect: 'Architect',
            builders: 'Bouwers',
            marketplace: 'Marktplaats',
            supplierList: 'Leverancierslijst',
            architectList: 'Architectenlijst',
            buildersList: 'Bouwerslijst',
            addPartner: 'Partner toevoegen',
            searchCompanyName: 'Zoeken op bedrijfsnaam',
            basicInfo: 'Basisinformatie',
            professionalInfo: 'Professionele informatie',
            profileImage: 'Profielfoto',
            enterCompanyName: 'Voer bedrijfsnaam in',
            enterPhone: 'Voer telefoonnummer in',
            enterWebsite: 'Voer website URL in',
            enterSpecialties: 'Voer specialiteiten in',
            enterExperience: 'Voer jaren ervaring in',
            profilePreview: 'Profielfoto voorbeeld',
            companyName: 'Bedrijfsnaam',
            phoneNumber: 'Telefoonnummer',
            website: 'Website',
            specialties: 'Specialiteiten',
            experience: 'Ervaring',
            profilePreview: 'Profielfoto voorbeeld',
            about: 'Over',
            bio: 'Bio',
            save: 'Opslaan',
            personalInformation: 'Persoonlijke informatie',
            companyInformation: 'Bedrijfsinformatie',
            supplier: 'Leverancier',
            architect: 'Architect',
            builders: 'Bouwers',
            overview: 'Overzicht',
            projects: 'Projecten',
            financial: 'Financieel',
            users: 'Gebruikers',
            roles: 'Rollen',
            settings: 'Instellingen',
            logout: 'Uitloggen',
            searchForAnything: 'Zoek naar alles',
            total: 'Totaal',
            pendingMilestoneApprovals: 'In behandeling',
            openIncidents: 'Openstaande incidenten',
            newSignups: 'Nieuwe inschrijvingen (Deze week)',
            alerts: 'Waarschuwingen',
            filters: 'Filters',
            incidents: 'Incidents',
            all: 'Alle',
            important: 'Belangrijk',
            pending: 'In behandeling',
            latestIncidents: 'Laatste incidenten',
            inspectorActivity: 'Activiteit van de inspecteur',
            escalationCenter: 'Escaladecentrum',
            projectDetails: 'Projectdetails',
            team: 'Team',
            download: 'Download',
            message: 'Bericht',
            architect: 'Architect',
            inspector: 'Inspector',
            currentMilestone: 'Huidige milesteen',
            escrowBalance: 'Escrow Saldo',
            latestUpdate: 'Laatste update',
            totalFundsHeld: 'Totaal aan gehouden fondsen',
            releasedThisMonth: 'Vrijgegeven deze maand',
            pendingMilestonePayouts: 'Payouts van milesteen in behandeling',
            platformRevenue: 'Platform omzet',
            milestoneLog: 'Milestone log',
            totalVendors: 'Totaal aan leveranciers',
            pendingApprovals: 'In behandeling',
            samplePendingVendor: 'Voorbeeld van wachtende leverancier',
            topProductsSold: 'Top verkochte producten',
            viewAll: 'Bekijk alles',
            selected: 'geselecteerd',
            addUser: 'Gebruiker toevoegen',
            registered: 'Geregistreerd',
            clients: 'Klanten',
            suppliers: 'Leveranciers',
            architects: 'Architecten',
            builders: 'Bouwers',
            inspectors: 'Inspecteurs',
            admins: 'Administrators',
            superAdmins: 'Super Administrators',
            verified: 'Geverifieerd',
            certified: 'Gecertificeerd',
            architects: 'Architecten',
            userList: 'Gebruikerslijst',
            profile: 'Profiel',
            changePassword: 'Wachtwoord wijzigen',
            firstName: 'Voornaam',
            lastName: 'Achternaam',
            contactNumber: 'Telefoonnummer',
            whatsappNumber: 'Whatsapp nummer',
            state: 'Staat',
            city: 'Stad',
            postalCode: 'Postcode',
            isWhatsappNo: 'Is Whatsapp Number',
            emailId: 'Email ID',
            companyName: 'Bedrijfsnaam',
            website: 'Website',
            languagePreference: 'Préférence de langue',
            role: 'Rol',
            street: 'Straat',
            country: 'Land',
            countryCode: 'Landcode',
            zip: 'Postcode',
            specialities: 'Specialiteiten',
            state: 'Staat',
            city: 'Stad',
            bio: 'Bio',
            roleDetails: 'Rol details',
            roleInformation: 'Informations de la fonction',
            roleName: 'Nom du rôle',
            description: 'Beschrijving',
            createdAt: 'Créé le',
            permissions: 'Permissions',
            loadingPermissions: 'Chargement des permissions...',
            searchPermissions: 'Rechercher des permissions...',
            totalPermissions: 'Total des permissions',
            filterBy: 'Filtrer par',
            allStatus: 'Tous les statuts',
            assigned: 'Assigné',
            unassigned: 'Non assigné',
            permissionName: 'Nom de la permission',
            status: 'Statut',
            actions: 'Actions',
            completed: 'Terminé',
            pending: 'En attente',
            inProgress: 'En cours',
            onHold: 'En attente',
            cancelled: 'Annulé',
            approved: 'Approuvé',
            rejected: 'Rejeté',
            faqs: 'FAQs',
            submitTicket: 'Enviar um ticket',
            selectCategory: 'Selecionar uma categoria',
            ifYourIssueIsNotCoveredInTheFAQPleaseOpenASupportTicket: 'Se seu problema não estiver coberto nas FAQ, por favor, abra um ticket de suporte.',
            subject: 'Assunto',
            submit: 'Enviar',
            yourRecentTickets: 'Seus tickets recentes',
            assignedProjects: 'Projetos atribuídos',
            inventoryTableView: 'Visualização de tabela de inventário',
            certification: 'Certificação',
            designStudio: 'Design Studio',
            designFileManager: 'Gestionnaire de fichiers de conception',
            uploadNewDesign: 'Nieuw ontwerp uploaden',
            clientFeedback: 'Client Feedback',
            inspections: 'Inspections',
            myBids: 'Meus pedidos',
            marketplace: 'Marketplace',
            inStock: 'En stock',
            stockStatus: 'Statut du stock',
            category: 'Catégorie',
            addNewProduct: 'Ajouter un nouveau produit',
            inventoryTableView: 'Vue de table de l\'inventaire',
            inspectorReports: 'Rapports de l\'inspecteur',
            incidentReportTable: 'Tableau des rapports d\'incidents',
            tabName: 'Nom de l\'onglet',
            accounts: 'Comptes',
            manageStaffMembers: 'Gérer les membres de l\'équipe',
            add: 'Ajouter',
            addStaff: 'Ajouter un membre de l\'équipe',
            addingStaff: 'Ajout d\'un membre de l\'équipe...',
            project: 'Projet',
            plot: 'Lote',
            submitPlot: 'Submit Plot',
            addingPlot: 'Adding Plot...',
            addProject: 'Project toevoegen',
            columns: 'Kolommen',
            projectName: 'Projectnaam',
            lotSize: 'Lotgrootte',
            projectInformation: 'Projectinformatie',
            addressInformation: 'Adresgegevens',
            plotInformation: 'Perceelinformatie',
            projectImages: 'Projectafbeeldingen',
            projectFiles: 'Projectbestanden',
            fileCabinet: 'Archiefkast',
            back: 'Rug',
            addFiles: 'Bestanden toevoegen',
            backtoProjects: 'Terug naar Projecten',
            editProject: 'Project bewerken',
            existingImages: 'Bestaande afbeeldingen',
            uploadNewImages: 'Nieuwe afbeeldingen uploaden',
            drag: 'Sleuren',
            dropimagestorearrange: 'afbeeldingen verwijderen om opnieuw te ordenen',
            fileName: 'Bestandsnaam',
            availability: 'Beschikbaarheid',
            visibility: 'Zichtbaarheid',
            files: 'Bestanden',
            backtoFileCabinet: 'Terug naar archiefkast',
            editFileCabinet: 'Archiefkast bewerken',
            noFileCabinetData: 'Geen archiefkastgegevens',
            existingFiles: 'Bestaande bestanden',
            goToFileCabinet: 'Terug naar archiefkast',
            plotDetails: 'Plot Details',
            plotImages: 'Plot Images',
            plotFiles: 'Plot Files',
            assign: 'Assign',
            addPlot: 'Plot toevoegen',
            accountInformation: 'Informations du compte',
            locationInformation: 'Informations de localisation',
            builder: 'Builder',
            inspector: 'Inspector',
            supplier: 'Supplier',
            client: 'Client',
            resetForm: 'Resetar formulário',
            submit: 'Enviar',
            addingUser: 'Adicionando usuário...',
            addingUser: 'Adicionando usuário...',
            companyName: 'Nome da empresa',
            showHideColumns: 'Mostrar/Ocultar colunas',
            deletingUser: 'Deleting user...',
            usersLoading: 'Users loading...',
            updating: 'Bijwerken...',
            updateProject: 'Project bijwerken',
            done: 'Klaar',
            selectArchitects: 'Selecteren architecten',
            selectBuilders: 'Selecteren constructeurs',
            selectSuppliers: 'Selecteren voorzieners',
            selectInspectors: 'Selecteren inspecteurs',
            addingPlot: 'Plot toevoegen...',
            submitPlot: 'Plot toevoegen',
            countryName: 'Land naam',
            stateName: 'Staat naam',
            cityName: 'Plaats naam',
            zipCode: 'Postcode',
            view: 'Bekijk',
            edit: 'Bewerken',
            delete: 'Verwijderen',
            deleting: 'Verwijderen...',
            noMessagesYet: 'Geen berichten nog',
            chat: 'Chat',
            loadingPlotDetails: 'Plot details laden...',
            clientInformation: 'Client informatie',
            folderName: 'Map naam',
            addingLot: 'Plot toevoegen...',
            submitLot: 'Plot toevoegen',
            plotName: 'Plot naam',
            plotSize: 'Plot grootte',
            plotDetails: 'Intrigue details',
            clientName: 'Naam van de klant',
            clientImage: 'Afbeelding van de klant',
            cabinetFiles: 'Fichiers do armário',
            hello: 'Hallo',
            quick: 'Snel',
            quickSearch: 'Snel zoeken',
            favorites: 'Favorieten',
            filter: 'Filter',
            home: 'Início',
            propertyType: 'Tipo de propriedade',
            myFilter: 'Meu filtro',
            addFilter: 'Adicionar filtro',
            editFilter: 'Editar filtro',
            apply: 'Aplicar',
            clearAll: 'Limpar tudo',
            personalInformation: 'Informações pessoais',
            profileInformation: 'Informações do perfil',
            contactDetails: 'Informações de contato',
            addressDetails: 'Informações de endereço',
            saveChanges: 'Salvar alterações',
            discardChanges: 'Descartar alterações',
            changeEmailId: 'Alterar o email',
            pushNotification: 'Notificação push',
            changePassword: 'Alterar a senha',
            logOut: 'Sair',
            price: 'Preço',
            rooms: 'Quartos',
            askInformation: 'Perguntar informações',
            areYouSureYouWantToLogout: 'Tem certeza que deseja sair?',
            confirmLogout: 'Confirmar saída',
            cancel: 'Cancelar',
            logOut: 'Sair',
            portfolioFilter: 'Portfoliofilter',
            location: 'Locatie',
            bedrooms: 'Slaapkamers',
            bathrooms: 'Badkamers',
            phoneNo: 'Telefoonnummer',
            noDataFound: 'Geen gegevens gevonden',
            pleaseWaitWhileWeFetchTheFavorites: 'Wachten terwijl we de favorieten ophalen',
            noPropertiesMatchYourCurrentFiltersTryAdjustingYourSearchCriteria: 'Geen eigenschappen overeenkomen met uw huidige filters. Pas uw zoekcriteria aan.',
            noPropertiesAvailableAtTheMoment: 'Geen eigenschappen beschikbaar op dit moment.',
            pleaseWaitWhileWeFetchTheNotifications: 'Wachten terwijl we de notificaties ophalen',
            noNotificationsFound: 'Geen notificaties gevonden',
            noNotificationsMatchYourCurrentFiltersTryAdjustingYourSearchCriteria: 'Geen notificaties overeenkomen met uw huidige filters. Pas uw zoekcriteria aan.',
            noNotificationsAvailableAtTheMoment: 'Geen notificaties beschikbaar op dit moment.',
            pleaseWaitWhileWeFetchTheProperties: 'Wachten terwijl we de eigenschappen ophalen',
            pleaseWaitWhileWeFetchTheFilters: 'Wachten terwijl we de filters ophalen',
            noFiltersFound: 'Geen filters gevonden',
            youHaveNotCreatedAnyFiltersYetClickAddFilterToCreateOne: 'Je hebt nog geen filters aangemaakt. Klik op "Filtro toevoegen" om een filter aan te maken.',
            pleaseWaitWhileWeFetchThePropertyDetails: 'Wachten terwijl we de eigenschappen ophalen',
            dimension: 'Dimensie',
            garage: 'Garage',
            parking: 'Parkeren',
            noNotifications: 'Geen notificaties',
            notifications: 'Notificaties',
            markAllAsRead: 'Marquer tout comme lu',
        }
    },
    pt: {
        translation: {
            architect: 'Arquiteto',
            welcome: 'Bem-vindo',
            login: 'Entrar',
            logout: 'Sair',
            partnerList: 'Lista de parceiros',
            partnerProfile: 'Perfil do parceiro',
            editPartner: 'Editar parceiro',
            language: 'Idioma',
            menu: 'Menu',
            email: 'E-mail',
            password: 'Senha',
            rememberMe: 'Lembrar-me',
            forgotPassword: 'Esqueceu a senha?',
            signIn: 'Entrar',
            dontHaveAccount: 'Não tem uma conta?',
            signUp: 'Cadastrar',
            search: 'Pesquisar',
            addNewPartner: 'Adicionar novo parceiro',
            name: 'Nome',
            phone: 'Telefone',
            status: 'Status',
            actions: 'Ações',
            edit: 'Editar',
            delete: 'Excluir',
            view: 'Visualizar',
            active: 'Ativo',
            inactive: 'Inativo',
            personalInfo: 'Informações pessoais',
            contactInfo: 'Informações de contato',
            address: 'Endereço',
            city: 'Cidade',
            country: 'País',
            postalCode: 'CEP',
            save: 'Salvar',
            cancel: 'Cancelar',
            update: 'Atualizar',
            confirmDelete: 'Tem certeza que deseja excluir?',
            yes: 'Sim',
            no: 'Não',
            loading: 'Carregando...',
            error: 'Erro',
            success: 'Sucesso',
            required: 'Obrigatório',
            invalidEmail: 'E-mail inválido',
            invalidPhone: 'Número de telefone inválido',
            saveSuccess: 'Salvo com sucesso',
            updateSuccess: 'Atualizado com sucesso',
            deleteSuccess: 'Excluído com sucesso',
            buildDreamHome: 'Construa sua casa dos sonhos',
            tagline: 'O PlanNbuild conecta você a arquitetos especializados, construtores verificados e inspetores no local, dando a você controle total, visibilidade e segurança em cada etapa da sua jornada de construção.',
            welcomeBack: 'Bem-vindo de volta ao PlanNbuild!',
            enterCredentials: 'Digite suas credenciais para acessar sua conta',
            enterEmail: 'Digite seu e-mail',
            enterPassword: 'Digite sua senha',
            supplier: 'Fornecedor',
            architect: 'Arquiteto',
            builders: 'Construtores',
            marketplace: 'Mercado',
            supplierList: 'Lista de fornecedores',
            architectList: 'Lista de arquitetos',
            buildersList: 'Lista de construtores',
            addPartner: 'Adicionar parceiro',
            searchCompanyName: 'Pesquisar por nome da empresa',
            basicInfo: 'Informações Básicas',
            professionalInfo: 'Informações Profissionais',
            profileImage: 'Imagem de Perfil',
            enterCompanyName: 'Digite o nome da empresa',
            enterPhone: 'Digite o número de telefone',
            enterWebsite: 'Digite a URL do site',
            enterSpecialties: 'Digite as especialidades',
            enterExperience: 'Digite os anos de experiência',
            profilePreview: 'Visualização do Perfil',
            companyName: 'Nome da empresa',
            phoneNumber: 'Número de telefone',
            website: 'URL do site',
            specialties: 'Especialidades',
            experience: 'Anos de experiência',
            profilePreview: 'Visualização do Perfil',
            about: 'Sobre',
            bio: 'Bio',
            save: 'Salvar',
            personalInformation: 'Informações pessoais',
            companyInformation: 'Informações da empresa',
            supplier: 'Fornecedor',
            architect: 'Arquiteto',
            builders: 'Construtor',
            overview: 'Visão Geral',
            projects: 'Projetos',
            financial: 'Financeiro',
            users: 'Usuários',
            roles: 'Funções',
            settings: 'Configurações',
            logout: 'Sair',
            searchForAnything: 'Pesquisar por qualquer coisa',
            total: 'Total',
            pendingMilestoneApprovals: 'Aprovações de pontos de marca pendentes',
            openIncidents: 'Incidentes abertos',
            newSignups: 'Novos inscritos (Esta semana)',
            alerts: 'Alertas',
            filters: 'Filtros',
            incidents: 'Incidentes',
            all: 'Todos',
            important: 'Importante',
            pending: 'Pendente',
            latestIncidents: 'Últimos incidentes',
            inspectorActivity: 'Atividade do inspetor',
            escalationCenter: 'Centro de escalada',
            projectDetails: 'Detalhes do projeto',
            team: 'Equipe',
            download: 'Download',
            message: 'Mensagem',
            architect: 'Arquiteto',
            inspector: 'Inspetor',
            currentMilestone: 'Milestone atual',
            escrowBalance: 'Saldo de escrow',
            latestUpdate: 'Última atualização',
            totalFundsHeld: 'Total de fundos mantidos',
            releasedThisMonth: 'Lançado este mês',
            pendingMilestonePayouts: 'Payouts de pontos de marca pendentes',
            platformRevenue: 'Receita da plataforma',
            milestoneLog: 'Log de pontos de marca',
            totalVendors: 'Total de fornecedores',
            pendingApprovals: 'Aprovações pendentes',
            samplePendingVendor: 'Exemplo de fornecedor pendente',
            topProductsSold: 'Produtos mais vendidos',
            viewAll: 'Ver todos',
            selected: 'selecionado',
            addUser: 'Adicionar usuário',
            registered: 'Registrado',
            clients: 'Clientes',
            suppliers: 'Fornecedores',
            architects: 'Arquitetos',
            builders: 'Construtores',
            inspectors: 'Inspetores',
            admins: 'Administradores',
            superAdmins: 'Super Administradores',
            verified: 'Verificado',
            certified: 'Certificado',
            architects: 'Arquitetos',
            userList: 'Lista de usuários',
            profile: 'Perfil',
            changePassword: 'Alterar senha',
            firstName: 'Nome',
            lastName: 'Sobrenome',
            contactNumber: 'Número de telefone',
            whatsappNumber: 'Número de WhatsApp',
            state: 'Estado',
            city: 'Cidade',
            postalCode: 'CEP',
            isWhatsappNo: 'É um número de WhatsApp',
            emailId: 'ID de e-mail',
            companyName: 'Nome da empresa',
            website: 'Site web',
            languagePreference: 'Preferência de idioma',
            role: 'Papel',
            street: 'Rua',
            country: 'País',
            countryCode: 'Código do país',
            zip: 'CEP',
            specialities: 'Especialidades',
            state: 'Estado',
            city: 'Cidade',
            bio: 'Bio',
            roleDetails: 'Detalhes da função',
            roleInformation: 'Informações da função',
            roleName: 'Nome da função',
            description: 'Descrição',
            createdAt: 'Criado em',
            permissions: 'Permissões',
            loadingPermissions: 'Carregando permissões...',
            searchPermissions: 'Pesquisar permissões...',
            totalPermissions: 'Total de permissões',
            filterBy: 'Filtrar por',
            allStatus: 'Todos os status',
            assigned: 'Atribuído',
            unassigned: 'Não atribuído',
            permissionName: 'Nome da permissão',
            status: 'Status',
            actions: 'Ações',
            completed: 'Completo',
            pending: 'Pendente',
            inProgress: 'Em progresso',
            onHold: 'Em espera',
            cancelled: 'Cancelado',
            approved: 'Aprovado',
            rejected: 'Rejeitado',
            faqs: 'FAQs',
            submitTicket: 'Enviar um ticket',
            selectCategory: 'Selecionar uma categoria',
            ifYourIssueIsNotCoveredInTheFAQPleaseOpenASupportTicket: 'Se seu problema não estiver coberto nas FAQ, por favor, abra um ticket de suporte.',
            subject: 'Assunto',
            submit: 'Enviar',
            yourRecentTickets: 'Seus tickets recentes',
            assignedProjects: 'Projetos atribuídos',
            inventoryTableView: 'Visualização de tabela de inventário',
            certification: 'Certificação',
            designStudio: 'Design Studio',
            designFileManager: 'Gestionnaire de fichiers de conception',
            uploadNewDesign: 'Carregar novo design',
            clientFeedback: 'Feedback do cliente',
            recentApprovalsTracker: 'Rastreamento de aprovações recentes',
            inspections: 'Inspeções',
            myBids: 'Meus pedidos',
            marketplace: 'Marketplace',
            inStock: 'Em estoque',
            stockStatus: 'Status do estoque',
            category: 'Categoria',
            addNewProduct: 'Adicionar novo produto',
            inventoryTableView: 'Visualização de tabela de inventário',
            inspectorReports: 'Relatórios do inspetor',
            incidentReportTable: 'Tabela de relatórios de incidentes',
            tabName: 'Nome da aba',
            accounts: 'Contas',
            manageStaffMembers: 'Gerenciar membros da equipe',
            add: 'Adicionar',
            addStaff: 'Adicionar membro da equipe',
            addingStaff: 'Adicionando membro da equipe...',
            project: 'Projeto',
            plot: 'Lote',
            submitPlot: 'Submit Plot',
            addingPlot: 'Adding Plot...',
            addProject: 'Adicionar Projeto',
            columns: 'Colunas',
            projectName: 'Nome do Projeto',
            lotSize: 'Tamanho do lote',
            projectInformation: 'Informações do Projeto',
            addressInformation: 'Informações de endereço',
            plotInformation: 'Informações do enredo',
            projectImages: 'Imagens do Projeto',
            projectFiles: 'Arquivos do Projeto',
            fileCabinet: 'Armário de arquivo',
            back: 'Costas',
            addFiles: 'Adicionar ficheiros',
            backtoProjects: 'Voltar para Projetos',
            editProject: 'Editar Projeto',
            existingImages: 'Imagens existentes',
            uploadNewImages: 'Carregar novas imagens',
            drag: 'Arrastar',
            dropimagestorearrange: 'soltar imagens para reorganizar',
            fileName: 'Nome do ficheiro',
            availability: 'Disponibilidade',
            visibility: 'Visibilidade',
            files: 'Arquivos',
            backtoFileCabinet: 'Voltar ao arquivo',
            editFileCabinet: 'Editar arquivo',
            noFileCabinetData: 'Nenhum arquivo de arquivo',
            existingFiles: 'Arquivos existentes',
            goToFileCabinet: 'Voltar ao arquivo',
            plotDetails: 'Detalhes do lote',
            plotImages: 'Imagens do lote',
            plotFiles: 'Arquivos do lote',
            assign: 'Atribuir',
            addPlot: 'Adicionar lote',
            accountInformation: 'Informações da conta',
            locationInformation: 'Informações de localização',
            builder: 'Builder',
            inspector: 'Inspetor',
            supplier: 'Fornecedor',
            client: 'Cliente',
            resetForm: 'Resetar formulário',
            submit: 'Enviar',
            addingUser: 'Adicionando usuário...',
            addingUser: 'Adicionando usuário...',
            companyName: 'Nome da empresa',
            showHideColumns: 'Mostrar/Ocultar colunas',
            deletingUser: 'Deleting user...',
            usersLoading: 'Users loading...',
            updating: 'Atualizando...',
            updateProject: 'Projeto de atualização',
            done: 'Feito',
            selectArchitects: 'Selecionar arquitetos',
            selectBuilders: 'Selecionar construtores',
            selectSuppliers: 'Selecionar fornecedores',
            selectInspectors: 'Selecionar inspetores',
            addingPlot: 'Adicionando plot...',
            submitPlot: 'Enviar plot',
            countryName: 'Land naam',
            stateName: 'Staat naam',
            cityName: 'Plaats naam',
            zipCode: 'Postcode',
            view: 'Bekijk',
            edit: 'Bewerken',
            delete: 'Verwijderen',
            deleting: 'Verwijderen...',
            noMessagesYet: 'Geen berichten nog',
            chat: 'Conversa',
            loadingPlotDetails: 'Plot details laden...',
            clientInformation: 'Informações do cliente',
            folderName: 'Nome da pasta',
            addingLot: 'Adicionar plot...',
            submitLot: 'Adicionar plot',
            plotName: 'Plot naam',
            plotSize: 'Plot grootte',
            plotDetails: 'Intrigue details',
            clientName: 'Nome do cliente',
            clientImage: 'Imagem do cliente',
            cabinetFiles: 'Fichiers do armário',
            hello: 'Olá',
            quick: 'Rápido',
            quickSearch: 'Pesquisa rápida',
            favorites: 'Favoritos',
            filter: 'Filtro',
            home: 'Início',
            propertyType: 'Tipo de propriedade',
            myFilter: 'Meu filtro',
            addFilter: 'Adicionar filtro',
            editFilter: 'Editar filtro',
            apply: 'Aplicar',
            clearAll: 'Limpar tudo',
            personalInformation: 'Informações pessoais',
            profileInformation: 'Informações do perfil',
            contactDetails: 'Informações de contato',
            addressDetails: 'Informações de endereço',
            saveChanges: 'Salvar alterações',
            discardChanges: 'Descartar alterações',
            changeEmailId: 'Alterar o email',
            pushNotification: 'Notificação push',
            changePassword: 'Alterar a senha',
            logOut: 'Sair',
            price: 'Preço',
            rooms: 'Quartos',
            askInformation: 'Perguntar informações',
            areYouSureYouWantToLogout: 'Are you sure you want to log out?',
            confirmLogout: 'Confirm Logout',
            cancel: 'Cancel',
            logOut: 'Log Out',
            portfolioFilter: 'Filtro de portfólio',
            location: 'Localização',
            bedrooms: 'Quartas',
            bathrooms: 'Banheiras',
            phoneNo: 'Número de telefone',
            noDataFound: 'Nenhum dado encontrado',
            pleaseWaitWhileWeFetchTheFavorites: 'Por favor, aguarde enquanto buscamos os favoritos',
            noPropertiesMatchYourCurrentFiltersTryAdjustingYourSearchCriteria: 'Nenhuma propriedade corresponde aos seus filtros atuais. Tente ajustar seus critérios de busca.',
            noPropertiesAvailableAtTheMoment: 'Nenhuma propriedade disponível no momento.',
            pleaseWaitWhileWeFetchTheNotifications: 'Por favor, aguarde enquanto buscamos as notificações',
            noNotificationsFound: 'Nenhuma notificação encontrada',
            noNotificationsMatchYourCurrentFiltersTryAdjustingYourSearchCriteria: 'Nenhuma notificação corresponde aos seus filtros atuais. Tente ajustar seus critérios de busca.',
            noNotificationsAvailableAtTheMoment: 'Nenhuma notificação disponível no momento.',
            pleaseWaitWhileWeFetchTheProperties: 'Por favor, aguarde enquanto buscamos as eigenschappen',
            pleaseWaitWhileWeFetchTheFilters: 'Por favor, aguarde enquanto buscamos os filtros',
            noFiltersFound: 'Nenhum filtro encontrado',
            youHaveNotCreatedAnyFiltersYetClickAddFilterToCreateOne: 'Você ainda não criou nenhum filtro. Clique em "Adicionar filtro" para criar um.',
            pleaseWaitWhileWeFetchThePropertyDetails: 'Por favor, aguarde enquanto buscamos as detalhes da propriedade',
            dimension: 'Dimensão',
            garage: 'Garagem',
            parking: 'Estacionamento',
            pleaseWaitWhileWeFetchThePropertyDetails: 'Por favor, aguarde enquanto buscamos as detalhes da propriedade',
            noNotifications: 'Nenhuma notificação',
            notifications: 'Notificações',
            markAllAsRead: 'Marcar todas como lidas',
        }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n; 